<template lang="pug">
  .desktop-actions
    .col.icons-container
      .row.headers
        h5 {{__('Connect')}}
        h5 {{__('App')}}
      .row.icons
        .row.social
          rogue-link(
            target='_blank'
            :to='href'
            v-for='(href, key) in socialLinks'
            :aria-label=`key + ' (opens in a new tab)'`
            :key="href"
          )
            Icon( :name='key' fill='white' )
          .vertical-line
          rogue-link(to='/rogue-app' :aria-label="__('Download our App')")
            Icon(name='cellphone' fill='white')
    .newsletter
      desktop-newsletter-signup
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { useRogue } from '@/js/services/Rogue'
import DesktopNewsletterSignup from '@/js/components/footer/desktop-newsletter-signup.vue'

const rogue = useRogue()

const DEFAULT_SOCIAL = {
  facebook  : 'https://www.facebook.com/roguefitness',
  youtube   : 'https://www.youtube.com/user/roguefitness/',
  instagram : 'https://instagram.com/roguefitness',
  twitter   : 'https://twitter.com/RogueFitness/',
  tiktok    : 'https://www.tiktok.com/@roguefitness',
}

const socialLinks = computed(() => rogue.site?.social || Object.assign({}, DEFAULT_SOCIAL))

</script>

<style lang="scss" scoped>
.desktop-actions {
  padding: $space-xs 0;
}

h5 {
  text-transform: uppercase;
}

.icons-container {
  flex-direction: column;
  width: 332px;
  max-width: 33.334%;
  .icon {
    width: 50px;
    height: 50px;
    cursor: pointer;
    opacity: 1;

    &:hover {
      opacity: 0.8;
    }
  }
}

.social {
  width: 355px;
  margin: $space-xxs 0 $space-s 0;
  margin-left: (-$space-xs);
  margin-right: (-$space-xs);
  justify-content: space-between;
}

.phone {
  text-align: center;

  .icon {
    margin-right: 0;
  }
}

.row {
  display: flex;
}

.headers{
  flex-direction: row;
  justify-content: space-between;
}

.vertical-line{
  height: 50px;
  width: 1px;
  background-color: #ffffff;
  margin: 0 10px;
}

.newsletter {
  width: 33.334%;
}
</style>
